import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { MessageHandler } from 'src/app/shared/handlers/message-handler';
import { MondelezDataService } from 'src/app/shared/services/mondelez-data.service';
import { MondelezService } from 'src/app/shared/services/mondelez.service';
import { MatDialogRef } from '@angular/material/dialog';
import * as FileSaver from 'file-saver';
import { GlobalService } from 'src/app/core/services/global.service';
import { AlertHandler } from 'src/app/core/handlers/alert-handler';
// import * as jsPDF from 'jspdf';
// import 'jspdf-autotable';
// import autoTable from 'jspdf-autotable'

interface ExportColumn {
  title: string;
  dataKey: string;
}

@Component({
  selector: 'app-steps-summary',
  templateUrl: './steps-summary.component.html',
  styleUrls: ['./steps-summary.component.scss'],
})
export class StepsSummaryComponent {
  masterData: any[];
  public supply_mode: string = 'manufacturing';
  public scenarioId: number;

  public supplyModeParam = [
    { key: 'manufacturing', description: 'Manufacturing', is_active: false },
    { key: 'logistics', description: 'Logistics', is_active: false },
  ];

  private iteration_code: number;
  private subscriptions = new Subscription();
  exportColumns: any[];

  constructor(
    private mondelezService: MondelezService,
    private mondelezDataService: MondelezDataService,
    private globalService: GlobalService,
    public dialogRef: MatDialogRef<StepsSummaryComponent>
  ) {}

  ngOnInit(): void {
    const accessList = this.globalService
      .getNavList()
      .filter((el) => el.screen_name === 'get-steps-summary' && el.is_active)
      .map((el) => el.supply_mode);
    if (accessList.length) this.supply_mode = accessList[0];
    this.supplyModeParam.map((el) => {
      if (accessList.includes(el.key)) {
        el.is_active = true;
      } else {
        el.is_active = false;
      }
      return el;
    });
    this.subscriptions.add(
      this.mondelezDataService.currentScenarioChanged.subscribe((res) => {
        this.scenarioId = res.scenario_id;
        this.iteration_code = res.iteration_code;
      })
    );
    this.getStepsSummary();
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onSupplyModeChange(mode: string): void {
    if (mode) {
      console.log('this.supply_mode,mode :>> ', this.supply_mode, mode);
      this.getStepsSummary();
    }
  }

  exportExcel() {
    import('xlsx').then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(this.masterData);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, 'Steps_Summary');
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // exportPdf() {
  //   import("jspdf").then(jsPDF => {
  //       import("jspdf-autotable").then(x => {
  //           const doc: any = new jsPDF.default('l', 'px');
  //           console.log(doc);
  //           doc.autoTable(this.exportColumns, this.masterData);
  //           doc.save('Steps_Summary.pdf');
  //       })
  //   })
  // }

  getStepsSummary(): void {
    this.mondelezService.getStepSummary({ supply_mode: this.supply_mode, scenario_id: this.scenarioId, iteration_code: this.iteration_code }).subscribe({
      next: (result: any) => {
        if (result && result.response === 'SUCCESS') {
          this.masterData = result.steps_summary;
          this.exportColumns = Object.keys(this.masterData[0]).map((el) => ({ title: el, dataKey: el }));
          // console.log(result.steps_summary);
        } else {
          AlertHandler.ErrorAlert(MessageHandler.INTERNAL_ERROR);
        }
      },
    });
  }
}
